<template>
  <div class="alipay-container">
    <!-- 面包屑导航 + 返回按钮 -->
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-document"></i> 订单详情
        </el-breadcrumb-item>
      </el-breadcrumb>
      <el-button type="text" @click="goBack" icon="el-icon-back" class="back-btn">返回</el-button>
    </div>

    <!-- 卡片内容 -->
    <el-card class="alipay-card" shadow="never">
      <!-- 步骤条 -->
      <div class="step-wrapper">
        <el-steps :active="activeStep" align-center finish-status="success">
          <el-step title="下单" :description="info.order_time ? dateFormat(info.order_time) : ''"></el-step>
          <el-step title="付款" :description="info.pay_time ? dateFormat(info.pay_time) : ''"></el-step>
          <el-step title="发货" :description="info.shipping_time ? dateFormat(info.shipping_time) : ''"></el-step>
          <el-step title="收货" :description="info.shipping_end_time ? dateFormat(info.shipping_end_time) : ''"></el-step>
          <el-step title="完成" :description="info.finish_time ? dateFormat(info.finish_time) : ''"></el-step>
        </el-steps>
      </div>

      <!-- 订单基本信息 -->
      <div class="info-section">
        <div class="section-title">
          <i class="el-icon-info"></i>
          <span>订单信息</span>
        </div>
        <el-descriptions :column="3" border size="small" class="info-descriptions">
          <el-descriptions-item label="订单编号">
            <span class="order-sn">{{ info.order_sn }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="会员账号">{{ info.user ? info.user.user_name : '-' }}</el-descriptions-item>
          <el-descriptions-item label="订单金额">
            <span class="amount">¥{{ info.order_amount }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="收货人">{{ info.consignee || '-' }}</el-descriptions-item>
          <el-descriptions-item label="收货电话">{{ info.tel || '-' }}</el-descriptions-item>
          <el-descriptions-item label="收货地址">{{ info.address || '-' }}</el-descriptions-item>
        </el-descriptions>
      </div>

      <!-- 商品列表 -->
      <div class="info-section">
        <div class="section-title">
          <i class="el-icon-goods"></i>
          <span>商品列表</span>
        </div>
        
        <div class="table-wrapper">
          <el-table
            ref="multipleTable"
            :data="info.goods_list"
            stripe
            border
            size="medium"
            :header-cell-style="headerCellStyle"
            v-loading="loading"
          >
            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
            <el-table-column label="商品名称" prop="name" min-width="250" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <div class="product-name">
                  <i class="el-icon-goods"></i>
                  <span>{{ scope.row.name }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="数量" prop="goods_number" width="100" align="center">
              <template slot-scope="scope">
                <span class="quantity">x {{ scope.row.goods_number }}</span>
              </template>
            </el-table-column>
            <el-table-column label="单价" prop="formated_shop_price" width="120" align="center">
              <template slot-scope="scope">
                <span class="price">¥{{ scope.row.formated_shop_price }}</span>
              </template>
            </el-table-column>
            <el-table-column label="小计" width="120" align="center">
              <template slot-scope="scope">
                <span class="total-price">¥{{ (scope.row.formated_shop_price * scope.row.goods_number).toFixed(2) }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 发货信息 -->
      <div class="info-section" v-if="info.shipping_status == 1">
        <div class="section-title">
          <i class="el-icon-truck"></i>
          <span>发货信息</span>
        </div>
        <el-descriptions :column="2" border size="small" class="info-descriptions">
          <el-descriptions-item label="运单号">{{ addForm.invoice_no || '-' }}</el-descriptions-item>
          <el-descriptions-item label="快递公司">{{ addForm.shipping_name || '-' }}</el-descriptions-item>
          <el-descriptions-item label="发货日期">{{ addForm.shipping_time || '-' }}</el-descriptions-item>
        </el-descriptions>
      </div>

      <!-- 发货表单（仅当未发货时显示） -->
      <div class="info-section" v-if="info.shipping_status != 1 && info.pay_status == 2">
        <div class="section-title">
          <i class="el-icon-s-promotion"></i>
          <span>发货处理</span>
        </div>
        
        <el-form :model="addForm" :rules="rules" ref="formForRef" label-width="90px" label-position="right" size="small">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="运单号" prop="invoice_no">
                <el-input 
                  v-model="addForm.invoice_no" 
                  placeholder="请输入运单号"
                  prefix-icon="el-icon-document"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="发货日期" prop="shipping_time">
                <el-date-picker 
                  v-model="addForm.shipping_time" 
                  type="datetime" 
                  placeholder="选择发货日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  prefix-icon="el-icon-date"
                  clearable
                  style="width: 100%;"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="快递公司" prop="shipping_name">
                <el-input 
                  v-model="addForm.shipping_name" 
                  placeholder="请选择快递公司"
                  prefix-icon="el-icon-truck"
                  suffix-icon="el-icon-arrow-down"
                  @focus="chooseS"
                  readonly
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <div class="form-actions">
            <el-button type="primary" @click="submitForm" icon="el-icon-check" size="medium">确认发货</el-button>
          </div>
        </el-form>
      </div>

      <!-- 已完成状态提示 -->
      <div class="info-section" v-if="info.shipping_status == 2">
        <div class="success-tip">
          <i class="el-icon-success"></i>
          <span>订单已完成，感谢您的购买！</span>
        </div>
      </div>

      <!-- 未支付状态提示 -->
      <div class="info-section" v-if="info.pay_status != 2">
        <div class="warning-tip">
          <i class="el-icon-warning"></i>
          <span>订单尚未支付，请等待用户完成支付</span>
        </div>
      </div>
    </el-card>

    <!-- 快递公司选择弹框 -->
    <eShopping 
      :formData="formData"
      :visible.sync="visible"
      :title="title"
      :closeForm="closeForm"
    />
  </div>
</template>

<script>
import moment from 'moment'
import eShopping from "../common/eShoppingList.vue";

export default {
  name: "shopOrderInfo",
  components: { eShopping },
  data() {
    return {
      loading: false,
      activeStep: 1,
      
      formData: {},
      title: '',
      visible: false,
      
      info: {},
      addForm: {
        order_id: '',
        invoice_no: '',
        shipping_name: '',
        shipping_id: '',
        shipping_time: '',
        shipping_status: 0,
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id'),
      },
      
      rules: {
        invoice_no: [
          { required: true, message: "请输入运单号", trigger: 'blur' }
        ],
        shipping_time: [
          { required: true, message: "请选择发货日期", trigger: 'change' }
        ],
        shipping_name: [
          { required: true, message: "请选择快递公司", trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    const id = this.$route.query.id
    if (id && !isNaN(id) && id > 0) {
      this.addForm.order_id = id
      this.getOne()
    } else {
      this.$message.error('订单ID不存在')
      this.goBack()
    }
  },
  methods: {
    headerCellStyle() {
      return {
        background: '#f5f7fa',
        color: '#1f2d3d',
        fontWeight: '500',
        fontSize: '13px',
        borderBottom: '1px solid #e4e7ed'
      }
    },
    
    closeForm() {
      this.addForm.shipping_name = this.formData.name
      this.addForm.shipping_id = this.formData.id
      this.visible = false
    },
    
    chooseS() {
      this.title = "选择快递公司"
      this.visible = true
    },
    
    dateFormat(time) {
      if (!time) return ""
      return moment(time * 1000).format("YYYY-MM-DD HH:mm:ss")
    },
    
    goBack() {
      this.$router.go(-1)
    },
    
    // 计算当前步骤
    setActiveStep() {
      if (this.info.finish_time) {
        this.activeStep = 5
      } else if (this.info.shipping_end_time) {
        this.activeStep = 4
      } else if (this.info.shipping_time) {
        this.activeStep = 3
      } else if (this.info.pay_time) {
        this.activeStep = 2
      } else {
        this.activeStep = 1
      }
    },
    
    submitForm() {
      this.$refs.formForRef.validate((valid) => {
        if (valid) {
          const params = {
            order_id: this.addForm.order_id,
            invoice_no: this.addForm.invoice_no,
            shipping_name: this.addForm.shipping_name,
            shipping_id: this.addForm.shipping_id,
            shipping_time: this.addForm.shipping_time,
            shipping_status: 1,
            access_token: this.addForm.access_token,
            company_id: this.addForm.company_id
          }
          
          this.$axios.shippingSave(params).then(res => {
            if (res.code == 200) {
              this.$message.success("发货成功")
              this.getOne()
            } else {
              this.$message.error(res.msg || "发货失败")
            }
          }).catch(error => {
            console.log(error)
            this.$message.error("发货失败")
          })
        }
      })
    },
    
    getOne() {
      this.loading = true
      const param = {
        access_token: this.addForm.access_token,
        company_id: this.addForm.company_id,
        order_id: this.addForm.order_id
      }
      
      this.$axios.orderInfo(param).then((res) => {
        this.loading = false
        if (res.code == 200) {
          this.info = res.data
          this.addForm.invoice_no = this.info.invoice_no || ''
          this.addForm.shipping_name = this.info.shipping_name || ''
          this.addForm.shipping_id = this.info.shipping_id || ''
          this.addForm.shipping_time = this.info.shipping_time ? this.dateFormat(this.info.shipping_time) : ''
          this.setActiveStep()
        } else {
          this.$message.error(res.msg || "获取订单详情失败")
        }
      }).catch(error => {
        this.loading = false
        console.error(error)
        this.$message.error("获取订单详情失败")
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.alipay-container {
  padding: 16px 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

// 面包屑样式
.breadcrumb-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  
  .el-breadcrumb {
    font-size: 14px;
    
    i {
      margin-right: 4px;
    }
  }
  
  .back-btn {
    color: #1677ff;
    
    &:hover {
      color: #4096ff;
    }
  }
}

// 卡片样式
.alipay-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08);
  }
}

.alipay-card .el-card__body {
  padding: 20px 24px;
}

// 步骤条样式
.step-wrapper {
  padding: 20px 40px;
  background: #f8f9fc;
  border-radius: 12px;
  margin-bottom: 24px;
  
  .el-step__title {
    font-size: 14px;
  }
  
  .el-step__description {
    font-size: 12px;
  }
}

// 信息区块样式
.info-section {
  margin-bottom: 28px;
  
  .section-title {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
    padding-left: 8px;
    border-left: 3px solid #1677ff;
    
    i {
      font-size: 16px;
      color: #1677ff;
    }
    
    span {
      font-size: 15px;
      font-weight: 600;
      color: #1f2d3d;
    }
  }
}

// 描述列表样式
.info-descriptions {
  ::v-deep .el-descriptions-item__label {
    background: #f8f9fc;
    font-weight: 500;
    color: #606266;
  }
  
  .order-sn {
    font-family: monospace;
    font-weight: 500;
    color: #1677ff;
  }
  
  .amount {
    color: #ff4d4f;
    font-weight: 600;
    font-size: 14px;
  }
}

// 表格样式
.table-wrapper {
  margin-bottom: 16px;
}

.el-table {
  border-radius: 12px;
  overflow: hidden;
}

.el-table::before {
  display: none;
}

.el-table th {
  background: #fafbfc !important;
  font-weight: 500;
}

.product-name {
  display: flex;
  align-items: center;
  gap: 8px;
  
  i {
    color: #e6a23c;
  }
}

.quantity {
  font-weight: 500;
  color: #e6a23c;
}

.price {
  color: #ff4d4f;
}

.total-price {
  color: #ff4d4f;
  font-weight: 600;
}

// 表单区域
.form-actions {
  display: flex;
  justify-content: center;
  margin-top: 16px;
  
  .el-button--primary {
    background: #1677ff;
    border-color: #1677ff;
    border-radius: 24px;
    padding: 10px 32px;
    
    &:hover {
      background: #4096ff;
      border-color: #4096ff;
    }
  }
}

// 提示样式
.success-tip {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 20px;
  background: #f0fdf4;
  border-radius: 12px;
  color: #00b578;
  
  i {
    font-size: 20px;
  }
  
  span {
    font-size: 14px;
  }
}

.warning-tip {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 20px;
  background: #fdf6ec;
  border-radius: 12px;
  color: #e6a23c;
  
  i {
    font-size: 20px;
  }
  
  span {
    font-size: 14px;
  }
}

// 表单样式
.el-form-item {
  margin-bottom: 20px;
}

.el-form-item .el-form-item__label {
  font-weight: 500;
  color: #1f2d3d;
}

.el-input .el-input__inner,
.el-select .el-input__inner {
  border-radius: 8px;
  border-color: #e4e7ed;
  transition: all 0.2s;
}

.el-input .el-input__inner:focus,
.el-select .el-input__inner:focus {
  border-color: #1677ff;
  box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.1);
}
</style>